import { render, staticRenderFns } from "./MesaEdit.vue?vue&type=template&id=c792240c&"
import script from "./MesaEdit.vue?vue&type=script&lang=js&"
export * from "./MesaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports